/**
 * Labstep
 *
 * @module components/Experiment/Card/EmptyState
 * @desc Empty state for Experiment
 */

import ExperimentWorkflowActionAddProtocol from 'labstep-web/components/ExperimentWorkflow/Action/AddProtocol';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import type { ExperimentEmptyStateProps } from './types';

export const ExperimentEmptyState: React.FC<
  ExperimentEmptyStateProps
> = ({ experimentWorkflow, ...rest }) => (
  <CardEmptyState
    title="No protocols"
    explanation="Add protocols to track the methods used in your experiment. Follow your protocols step-by-step and link the inventory items used in each protocol."
    src="/img/empty-state/protocols.svg"
    action={
      <ExperimentWorkflowActionAddProtocol
        experimentWorkflow={experimentWorkflow}
      />
    }
    {...rest}
  />
);
